import React, { Component } from "react"
import classnames from "classnames"
import styles from "./ArticlePage.less"
import componentParser from "AtomicUtils/componentParser"
import dateHandler from 'AtomicUtils/dateHandler'
import { Caption, Content, Section, BackButton, Space } from 'AtomicComponents'
import { Image, Heading, FullWidthImageSection } from "AtomicContainers"

export const ArticleHeader = props => (
  <div className={classnames({
    [styles.ArticleHeader]: true
  })}>
    <BackButton
      small
      href={props.backUrl}
      backText={props.backText || "Beyond the drive"} />
    {props.publishDate && <Caption>POSTED ON {props.publishDate}</Caption>}
  </div>
)

class ArticlePage extends Component {
  render() {
    const {
      preHeading,
      heading,
      description,
      content,
      featureImage,
      featureImageCaption,
      styleName,
      publishDate,
      backUrl,
      backgroundColor,
      children,
      components,
      hero
    } = this.props
    const dateString = new dateHandler(publishDate).format('D/M/YYYY')

    return (
      <Section fullWidth backgroundColor={backgroundColor}>
        <ArticleHeader publishDate={dateString} backUrl={backUrl} />
        {componentParser(hero)}
        {
          styleName === "news" ?
          featureImage && (
            <Section horizontalPadding>
              <Space />
              <Space />
              <Image
                src={featureImage}
                alt={heading} />
              <Content textAlign="center"><label>{featureImageCaption}</label></Content>
            </Section>
          ) :
          featureImage && (
            <FullWidthImageSection
              backgroundImage={featureImage}
              align="center"
              textAlign="center"
              height="tall">
              <Heading value={heading} preHeading={preHeading} white />
              <Content xmlString={description} theme="dark" />
            </FullWidthImageSection>
          )
        }
        {
          styleName === "news" ?
          (heading || preHeading || description || content) && (
            <Section padding>
              <Heading value={heading} preHeading={preHeading} />
              {description && <Content xmlString={description} />}
              {content && <Content xmlString={content} />}
            </Section>
          )
          :
          <Content xmlString={content} />
        }
        {components && componentParser(components)}
        {!components && children}
      </Section>
    )
  }
}

export default ArticlePage



// WEBPACK FOOTER //
// ./src/AtomicContainers/ArticlePage/ArticlePage.jsx